module.exports = __webpack_public_path__ + "static/img/main.c077941.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/aboutWe/main.jpg
// module id = d3Nf
// module chunks = 3